export default __webpack_public_path__ + "images/infoBlue.v-3978829bf4d70543c184f4093a827263.svg";